import lazyImport from '../../../Utils/Loading/loadingHelpers'

export const Skeleton = lazyImport(() => import('@mui/material/Skeleton'))
